import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

export default function TextField({
	className,
	id,
	name,
	narrow,
	placeholder,
	value,
	...rest
}) {
	const classes = cn('c-input', {
		'c-input--narrow': narrow
	}, className)

	return (
		<input
			className={classes}
			id={id}
			name={name}
			placeholder={placeholder}
			type="text"
			value={value}
			{...rest}
		/>
	)
}

TextField.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	narrow: PropTypes.bool,
	placeholder: PropTypes.string,
	value: PropTypes.string
}

TextField.defaultProps = {
	className: '',
	narrow: false,
	placeholder: '',
	value: ''
}
